var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"placement":_vm.placement,"disabled":_vm.disabled,"effect":_vm.effect,"popper-class":_vm.popperClass,"content":_vm.content}},[(_vm.htmlContent)?_c('div',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.htmlContent))},slot:"content"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }